import React, { Component } from 'react';
import CallsListItem from '../CallsListItem/CallsListItem';
import Loading from "../../common/Loading/Loading";
import { LeadsCallbacksCount } from './LeadsCallbacksCount';

const alert_sound = new Audio('/build/audio/alert.mp3');

let can_play_alert = false;

alert_sound.addEventListener('canplay', () => {
  can_play_alert = true;
});

let first_render = true;

window.alert_sound = alert_sound;

const calls_hash = {};

export default class CallsList extends Component{

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidUpdate() {
    const {
      data: {
        loading,
        calls,
      },
      onLoad
    } = this.props;

    if(!loading && onLoad) {
      onLoad(calls);
    }

    !loading && calls.forEach(call => {

      if(!calls_hash[call.id]){
        can_play_alert && !first_render && alert_sound.play();
        calls_hash[call.id] = true;
      }

    });

    first_render && (first_render = false);
  }

  render() {

    const {data: {loading, calls}, app_data, onLoad} = this.props;

    console.log(loading, calls)
    if(loading) {
      return (<Loading/>);
    }

    const calls_answered = calls.reduce((hash, call) => {
      if(call.answered || call.call_type == 2) {
        hash[call.phone] = true;
      }

      return hash;
    }, {});

    const calls_sorted = [...calls].sort((a, b) => {
      const a_date = new Date(a.date).valueOf();
      const b_date = new Date(b.date).valueOf();

      const a_not_answered = !a.answered && !calls_answered[a.phone];
      const b_not_answered = !b.answered && !calls_answered[b.phone];

      if(a_not_answered && !b_not_answered){
        return -1;
      } else if(!a_not_answered && b_not_answered) {
        return 1;
      }

      if(a_date > b_date){
        return -1;
      } else if(a_date < b_date) {
        return 1;
      }

      return 0;
    });

    return (
      <div className={``}>

        <h1>Звонки</h1>
        <LeadsCallbacksCount />

        <table className={`table fixed full_width`}>

          <thead className={`table__thead`}>

          <tr>

            <th className="calls__th_id">ID</th>
            <th className="calls__th_date">Дата</th>
            <th className="calls__th_duration">Длительность</th>
            <th className="calls__th_phone">Телефон</th>
            <th className="calls__th_client">Клиент</th>
            <th>Обращения</th>

          </tr>

          </thead>

          <tbody>

          {calls_sorted.map((call) => {

            return <CallsListItem key={call.id} call={call} app_data={app_data}/>

          })}

          </tbody>

        </table>

      </div>
    );
  }
}

